import { Box, getVariant } from '@apia/theme';
import { IConfirm } from '../../dialogs';
import { getLabel } from '@apia/util';
import { MouseEvent, useCallback } from 'react';
import { DialogButtonBar } from './DialogButtonBar';
import { SimpleButton } from '../../forms/buttons/SimpleButton';
import { useModalContext } from '../ModalContext';

export const Confirm = ({
  children,
  additionalButtons,
  additionalButtonsOnRight,
  cancelButtonText: cancelText = getLabel('btnCan').text,
  className,
  confirmButtonText: confirmText = getLabel('btnCon').text,
  confirmButtonVariant = 'primary',
  contentRef,
  disabled,
  hideCancelButton,
  hideConfirmButton,
  isLoading,
  onCancel,
  onConfirm,
  variant,
}: Omit<IConfirm, 'title'>) => {
  const { descriptionId } = useModalContext();

  return (
    <Box
      {...getVariant(variant ?? 'layout.common.modals.confirm')}
      className={`${className ?? ''} confirm`}
    >
      <Box ref={contentRef} className="confirm__content" id={descriptionId}>
        {children}
      </Box>
      <DialogButtonBar className="confirm__buttonBar">
        <Box
          className="confirm__customButtons"
          onClick={useCallback(
            (ev: MouseEvent) => {
              if ((ev.target as HTMLElement).closest('button')) onCancel?.();
            },
            [onCancel],
          )}
        >
          {additionalButtons}
        </Box>

        <Box className="confirm__defaultButtons">
          <Box
            className="confirm__customButtonsOnRight"
            onClick={useCallback(
              (ev: MouseEvent) => {
                if ((ev.target as HTMLElement).closest('button')) onCancel?.();
              },
              [onCancel],
            )}
          >
            {additionalButtonsOnRight}
          </Box>
          {!hideConfirmButton && (
            <SimpleButton
              onClick={onConfirm}
              title={confirmText}
              variant={confirmButtonVariant}
              disabled={isLoading ?? disabled}
              isLoading={isLoading}
              className="confirm__confirmButton"
              type="submit"
            >
              {confirmText}
            </SimpleButton>
          )}
          {onCancel && !hideCancelButton && (
            <SimpleButton
              onClick={onCancel}
              title={cancelText}
              {...getVariant('secondary')}
              disabled={isLoading}
              className="confirm__cancelButton"
            >
              {cancelText}
            </SimpleButton>
          )}
        </Box>
      </DialogButtonBar>
    </Box>
  );
};
